import { FieldRenderProps } from 'react-final-form';

export const Hidden = <T,>({ input: { name, value } }: FieldRenderProps<T>) => (
  <input style={{ display: 'none' }} name={name} type="hidden" value={`${value || ''}`} />
);
